import React from "react";
import FormatHelper from "@client.utils/FormatHelper";
import CostIndexValue from "@client.components/CostIndexValue";
import MeetingTypes from '@client.enums/meetingTypes';

const renderIndexValue = (value, isCostIndexPresentation) => {
  return isCostIndexPresentation ? (
    <CostIndexValue value={value} />
  ) : (
    FormatHelper.getCurrency(value)
  );
};

const getIntegerGetter = (data, field, isCostIndexPresentation) => {
  return isCostIndexPresentation ? parseInt(data[field]) : data[field];
};

const getInvestmentScoreHeader = (t, term, isCostIndexPresentation) => {
  return t(`${term}.${isCostIndexPresentation ? "score" : "amount"}`);
};

const renderMeetingTypeValue = (t, value) => {
  const terms = {
    [MeetingTypes.Recurring]: "components.Charts.totalMeetingsCost.recurring",
    [MeetingTypes.Unique]: "components.Charts.totalMeetingsCost.unique",
    [MeetingTypes.External]: "components.Charts.totalMeetingsCost.external"
  };

  return t(terms[value]);
}

export { renderIndexValue, renderMeetingTypeValue, getIntegerGetter, getInvestmentScoreHeader };
